import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, QrCode, Download } from "lucide-react";
import { toast } from "sonner";
import QrModal from "@/components/QrModal";

const LINKS = [
  { href: "#reconocimientos", label: "Reconocimientos" },
  { href: "#ejes", label: "Ejes y Logros" },
  { href: "#mapa", label: "Impacto en Colonias" },
  { href: "#fact-checking", label: "Evidencias" },
  { href: "#propuestas", label: "Participa" },
];

export default function Navbar({ config }) {
  const [open, setOpen] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  return (
    <>
    <header className="fixed top-0 inset-x-0 z-50 bg-arena-sand/80 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[4.5rem] flex items-center justify-between gap-4">
        <a href="#hero" data-testid="navbar-logo" className="flex items-center gap-3 shrink-0" aria-label="Ir al inicio — Tampico">
          <img src="/logo-tampico.webp" alt="Tampico" className="h-12 w-auto object-contain" />
        </a>
        <nav className="hidden lg:flex items-center gap-7" aria-label="Secciones del portal">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-gris hover:text-guinda transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            type="button"
            data-testid="navbar-qr-button"
            aria-label="Mostrar código QR del portal"
            onClick={() => setQrOpen((v) => !v)}
            className="p-2 rounded-full text-gris hover:text-guinda hover:bg-arena-light transition-colors duration-200"
          >
            <QrCode className="w-[18px] h-[18px]" />
          </button>
          <button
            type="button"
            data-testid="navbar-descargar-informe"
            onClick={() => {
              const url = config?.informe_pdf_url;
              if (url && url !== "#") {
                window.open(url, "_blank", "noopener,noreferrer");
              } else {
                toast.info("El informe impreso estará disponible próximamente para descarga");
              }
            }}
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-guinda hover:bg-guinda-dark text-white text-sm font-medium px-5 py-2 transition-colors duration-200"
          >
            <Download className="w-4 h-4" aria-hidden="true" />
            Descargar Informe
          </button>
          <button
            data-testid="navbar-menu-button"
            aria-label={open ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-gris hover:text-guinda"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <motion.nav
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
          className="lg:hidden border-t border-border bg-arena-sand px-5 py-4 flex flex-col gap-1"
          aria-label="Menú móvil"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => setOpen(false)}
              className="py-2.5 text-sm text-gris hover:text-guinda border-b border-border/60 last:border-0"
            >
              {l.label}
            </a>
          ))}
          <button
            type="button"
            data-testid="nav-mobile-descargar-informe"
            onClick={() => {
              setOpen(false);
              const url = config?.informe_pdf_url;
              if (url && url !== "#") {
                window.open(url, "_blank", "noopener,noreferrer");
              } else {
                toast.info("El informe impreso estará disponible próximamente para descarga");
              }
            }}
            className="py-2.5 text-left text-sm font-medium text-guinda inline-flex items-center gap-2"
          >
            <Download className="w-4 h-4" aria-hidden="true" />
            Descargar Informe
          </button>
        </motion.nav>
      )}
    </header>
    <QrModal open={qrOpen} />
    </>
  );
}
